import {getResource, postForm} from './BaseRequests'

export const fetchCatSavings = (cat_id, success, fail) => {
    getResource("category_savings", {id: cat_id}).then(success).catch(fail)
};